module.exports = __webpack_public_path__ + "img/avatar3.45498c7e.png";